module.exports = __webpack_public_path__ + "media/images/face_shield_mask-f67d0f98de27cd3a0da5c402b34a1ae6.svg";